export default __webpack_public_path__ + "static/media/fniris4.48db261a.png";